import { getBoundaries } from '../../../helpers/state-selector'
import stateHelper from '../../../helpers/state-abbreviation'
import moverHelper from '../../../helpers/mover-helper'
import mapHelper from '../../../helpers/map-helper'
import * as parse from 'wellknown'
import * as polylabel from 'polylabel'

export default {
  name: 'get-code',
  data () {
    return {
      moveSize: 42,
      moveDate: 62,
      undersoldLeads: 32,
      areaCodes: {},
      state: null,
      loading: true,
      stateData: {},
      current_size: 24,
      showCodeHelp: false,
      showUnselectAreaHelp: false,
      bound:null,
      all_selected: false
    }
  },
  beforeRouteEnter: function (to, from, next) {
    let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

    if (user && user.completed_process) {
      next('/thankyou');
    }
    next(true);
  },
  created () {
  },
  mounted () {
    console.log(this.$route.params.state)
    this.$store.commit('setSelectedState', this.$route.params.state)
    
    this.showInitialHelperMsg();
    this.checkMap()
    this.retriveStateData();
    this.getFilterSet();
    this.$store.dispatch('removeSelectedAreas')
  },
  destroyed () {
    this.$store.dispatch('removeAreaCodes');
  },
  methods: {
    showInitialHelperMsg: function() {
      let showText = localStorage.getItem('showGetCodeHelpText');
      if(!showText){
        this.showCodeHelp = true
        localStorage.setItem('showGetCodeHelpText', true)
        setTimeout(() =>{
          this.showCodeHelp = false
        }, 5000)
      }
    },
    showUnselectHelperMsg() {
      let showUnselectText = localStorage.getItem('showUnselectAreaHelpText');
      if(!showUnselectText){
        this.showUnselectAreaHelp = true
        localStorage.setItem('showUnselectAreaHelpText', true)
        setTimeout(() =>{
          this.showUnselectAreaHelp = false
        }, 5000)
      }
    },
    closeHelperMsg(id) {
      document.getElementById(id).style.display = 'none';
    },
    unselectPolygon (polygon) {
      polygon.setOptions({ strokeOpacity: 0, fillOpacity: 0 })
    },
    getFilterSet() {
      let state = this.$store.getters.selectedState;
      let selected_area = moverHelper.getSelectedArea(state);

      if (selected_area && selected_area.filter_set_id && !selected_area.area_codes.length) {
        let api_url = process.env.API_URL + '/filtersets/'+selected_area.filter_set_id+"?token="+this.$store.getters.accessToken;
        if(selected_area.status == "Active"){
          this.$http.get(api_url).then(response => {
            let filter_set = response.data || response;
            moverHelper.setStatesAreaCode(state, filter_set);
            console.log('filter set data', filter_set);
          })
        }
      }
    },
    setZoom(zoom){
      this.$store.getters.map.setZoom(zoom)
    },
    checkMap() {
      this.loading = true
      this.show_tag_box = true

        mapHelper._isGoogleLoaded({infobox:true}).then(val =>{
          mapHelper.refreshMap().then(val=> {
            let boundaries = getBoundaries()
            this.bound =  new google.maps.LatLngBounds()
            
            for (let i = 0; i < boundaries[ this.$store.getters.selectedState ].length; i++) {
              let point = new google.maps.LatLng(boundaries[ this.$store.getters.selectedState ][i].lat(), boundaries[ this.$store.getters.selectedState ][i].lng())
              this.bound.extend(point)
            }
            this.showAreaCodePolygons()
          })
        })
    },
    polygonHoverListners(city){
      google.maps.event.addListener(city.polygon, 'mouseover', () => {
        if(city.mapLabel){
          city.mapLabel.setContent("<div style='font-size:"+this.current_size+"px;' class='maplabel map_label_selected fs-1 text-center '>"+city.display+"</div>")
          city.polygon.setOptions({fillColor: '#DF5435',strokeColor: '#DF5435'})
        }
      })
      google.maps.event.addListener(city.polygon, 'mouseout', () => { 
        if (city.mapLabel && !city.selected ){
          city.mapLabel.setContent("<div style='font-size:"+this.current_size+"px;' class='maplabel fs-1 text-center '>"+city.display+"</div>")
          city.polygon.setOptions({fillColor: '#8A8E93',strokeColor: '#8A8E93'})
        } 
      })
    },
    polygonClickListners(city){
      google.maps.event.addListener(city.polygon, 'click', () => { 
        if (city.mapLabel && !city.selected ){
          city.mapLabel.setContent("<div style='font-size:"+this.current_size+"px;' class='maplabel map_label_selected fs-1 text-center '>"+city.display+"</div>")
          city.polygon.setOptions({fillColor: '#DF5435',strokeColor: '#DF5435'})
          this.selectAreaCode(city)
        }
        else{
          city.mapLabel.setContent("<div style='font-size:"+this.current_size+"px;' class='maplabel fs-1 text-center '>"+city.display+"</div>")
          city.polygon.setOptions({fillColor: '#8A8E93',strokeColor: '#8A8E93'})
          this.unselectAreaCode(city)
        } 
      }) 
    },
    createMapLabel(city, myLatLng){
      city.mapLabel = new InfoBox({
        content: "<div id="+city.area_code+" style='font-size:"+this.current_size+"px;' class='maplabel fs-1 text-center '>"+city.display+"</div>",
        disableAutoPan: false,
        maxWidth: city.width,
        alignBottom: true,
        pixelOffset: new google.maps.Size(-35, 20),
        position: myLatLng,
        zIndex: null,
        boxStyle: {
          opacity: 1,
          zIndex: 1,
          width: city.width+"px",
          height: "50px",
          overflow: "hidden",
          color: "#DF5435",
        },
        closeBoxURL: "",
        infoBoxClearance: new google.maps.Size(1, 1),
        enableEventPropagation: true
      });
      // city.mapLabel.setPosition()
      city.mapLabel.open(this.$store.getters.map)
    },
    setZoomAndSize(){
      if(this.$store.getters.areaCodes.length > 10){
        this.current_size = 18
        this.setZoom(8)
      }
      else{
        this.current_size = 24
      }
    },
    createPolygon(city,tmp){
      city.polygon = new google.maps.Polygon({
          paths : tmp,
          strokeColor : '#8A8E93',
          strokeOpacity : 0.8,
          strokeWeight : 4,
          fillColor : '#8A8E93',
          fillOpacity : 0.3,
          zIndex: 1,
      });
      city.polygon.setMap(this.$store.getters.map);
    },
    getCenter(city,shape, tmp2){
      let geojson = parse(shape)
      let center = null;
      if(tmp2.length > 1){
        let pos = city.polygon.my_getBounds().getCenter();
        center = [pos.lng(),pos.lat()]
      }
      else{
        center = polylabel(geojson.coordinates, 1.0);
      }

      let lat = center[1]
      let lng = center[0]

      var marker = new google.maps.Marker({
        position: {lat: lat, lng: lng},
        map: this.$store.getters.map
      });
      marker.setVisible(false)
      let myLatLng = city.polygon.my_getBounds().getCenter()

      if(!google.maps.geometry.poly.containsLocation(myLatLng, city.polygon)){
        myLatLng = marker.getPosition()
      }
      return myLatLng
    },
    checkForAdditionalAreaCode(city,areacode){
      if(!city.additional_areacodes)
        city.additional_areacodes = []
      city.display += "/"+areacode
      city.width +=35
      let ad = {
        areacode: areacode,
        flag: "extra"
      }
      let index = _.find(this.$store.getters.areaCodes,(area)=>{ return area.area_code == areacode })
      if(index && index.area_code){
        ad.flag = "true"
        ad.zipcode_list = index.zipcode_list
      }
      city.additional_areacodes.push(ad)
      return city
    },
    showAreaCodePolygons () {

      this.$store.getters.map.fitBounds(this.bound)
      this.state = this.$store.getters.selectedState
      let state_abbr = stateHelper.getAbbreviationByState(this.state);
      let api_url = process.env.API_URL + '/areacodes/get-by-state/'+state_abbr;

      this.$http.get('https://valet.irelo.com/api/service/areacodes/' + this.$store.getters.selectedState).then(response => {
        this.$store.commit("setAreaCodes", response.data);
        let selected_area = moverHelper.getSelectedArea(this.$store.getters.selectedState);
        this.setZoomAndSize()
        let context = this;
        context.$http.get(api_url).then(response => {

          if(!response.data.areacodes || response.data.areacodes.length == 0 )
            return
          
          let areacodes = response.data.areacodes 
          if (selected_area) {
            this.all_selected = selected_area.area_codes.length == areacodes.length;
          }

          _.forEach(this.$store.getters.areaCodes,(city) => {
            let areacode = areacodes.find(area=>{return area.npa == city.area_code })
            if(!areacode)
              return
            city.display = city.area_code
            city.width = 70;

            if(areacode.npa_2){
              city = this.checkForAdditionalAreaCode(city,areacode.npa_2)
            }
            if(areacode.npa_3){
              city = this.checkForAdditionalAreaCode(city,areacode.npa_3)
            }

            city.zindex = areacode.zindex
            let tmp = context.parsePolyStrings(areacode.shape);
            let tmp2 = tmp;
            if (tmp.length) {
              if(tmp2.length > 1){
                tmp = tmp2[0]
              }
              
              context.createPolygon(city,tmp)
              let myLatLng = context.getCenter(city,areacode.shape,tmp2)
              context.createMapLabel(city, myLatLng)
              context.polygonHoverListners(city)
              context.polygonClickListners(city)
            }           
          })

          context.initialziSelected()
          context.checkForInnerPolygons()
        })
      }, response => {
      })
    },
    checkForInnerPolygons(){

      _.forEach(this.$store.getters.areaCodes, (item) => {
        if(item.zindex && item.polygon && item.mapLabel){
          item.mapLabel.setZIndex(3)
          item.polygon.setOptions({zIndex: 3})
          if(item.area_code == 213){
            item.mapLabel.setZIndex(3000)
            item.polygon.setOptions({zIndex: 3000})
              
          }
          return 
        }
        else{
          if(item.polygon && item.mapLabel){
            let center = new google.maps.LatLng(item.mapLabel.getPosition().lat(), item.mapLabel.getPosition().lng())
            _.forEach(this.$store.getters.areaCodes, (next_item) =>{
              if(item.area_code != next_item.area_code && next_item.polygon && center){
                if(google.maps.geometry.poly.containsLocation(center,next_item.polygon)){
                  item.mapLabel.setZIndex(2)
                  item.polygon.setOptions({zIndex: 2})
                }
              }
            })
          }
        } 

      })

    },
    initialziSelected () {
      this.loading = false
      
      let selected_area = moverHelper.getSelectedArea(this.$store.getters.selectedState);
      let area_codes = this.$store.getters.areaCodes
      if (!selected_area) {  return; }

      _.forEach(selected_area.area_codes, (code) => {
        if(!area_codes.length){
          return
        }
        var index = area_codes.findIndex(acode => { return acode.area_code == code.area_code })
        if( index > -1 && area_codes[index].mapLabel ){
          area_codes[index].selected = true
          area_codes[index].mapLabel.setContent("<div style='font-size:"+this.current_size+"px;' class='maplabel map_label_selected fs-1 text-center '>"+area_codes[index].display+"</div>")  
          area_codes[index].polygon.setOptions({fillColor: '#DF5435',strokeColor: '#DF5435'})
        }
      })
     
    },
    selectAreaCode (state) {
      console.log('state', state)
      // console.log(city, this.$store.getters.selectedState)
      let selected_area = moverHelper.getSelectedArea(this.$store.getters.selectedState);
      if (selected_area && selected_area.filter_set_id) {
        selected_area.total_area_codes = this.$store.getters.areaCodes.length; 
      }
      if (!selected_area) {
        selected_area = {
          filter_set_id: null, 
          abbreviation: state.state,
          state: stateHelper.getStateByAbbreviation(state.state),
          area_codes: [],
          total_area_codes: this.$store.getters.areaCodes.length 
        }
        this.$store.dispatch('addSelectedArea', selected_area);
      }

      if (!selected_area.area_codes.length) {
        this.showUnselectHelperMsg();
      }

      selected_area.status = "Active"
      let index = _.findIndex(selected_area.area_codes, area => {return area.area_code == state.area_code})
      if(index < 0){
        selected_area.area_codes.push({
          area_code: state.area_code,
          zip_code: state.zipcode_list || state.zipcode,
          additional_areacodes: _.map(_.filter(state.additional_areacodes, ['flag', 'extra']),'areacode')
        })

        _.forEach(_.filter(state.additional_areacodes, ['flag', 'true']), (code)=>{
          selected_area.area_codes.push({
            area_code: code.areacode,
            zip_code: code.zipcode_list || []
          })
        })

        this.$store.commit('updateSelectedArea', selected_area);
      }
      state.selected = true
      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
    },
    unselectAreaCode (state) {
      //remove area code from list
      // this.$store.dispatch('removeAreaCode',city,this.$store.getters.selectedState)
      let selected_area = moverHelper.getSelectedArea(this.$store.getters.selectedState);
      console.log(state, "state")
      selected_area.area_codes = _.filter(selected_area.area_codes, (next_item) => {
        return next_item.area_code != state.area_code;
      });

      _.forEach(_.filter(state.additional_areacodes, ['flag', 'true']), (code)=>{
        selected_area.area_codes = _.filter(selected_area.area_codes, (next_item) => {
          return next_item.area_code != code.areacode;
        });
      })



      this.$store.commit('updateSelectedArea', selected_area);
      if (!selected_area.area_codes.length) {
        this.$store.commit('removeSelectedArea', selected_area.abbreviation);
      }

      state.selected = false;
      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
    },
    parsePolyStrings(ps) {
      var i, j, lat, lng, tmp, tmpArr,
          arr = [],
          //match '(' and ')' plus contents between them which contain anything other than '(' or ')'
          m = ps.match(/\([^\(\)]+\)/g);
      if (m !== null) {
          for (i = 0; i < m.length; i++) {
              //match all numeric strings
              tmp = m[i].match(/-?\d+\.?\d*/g);
              if (tmp !== null) {
                  //convert all the coordinate sets in tmp from strings to Numbers and convert to LatLng objects
                  for (j = 0, tmpArr = []; j < tmp.length; j+=2) {
                      lng = Number(tmp[j]);
                      lat = Number(tmp[j + 1]);
                      tmpArr.push(new google.maps.LatLng(lat, lng));
                  }
                  arr.push(tmpArr);
              }
          }
      }
      //array of arrays of LatLng objects, or empty array
      return arr;
    },
    unselectEntireState() {
      let state = this.$store.getters.selectedState;
      let selected_area = moverHelper.getSelectedArea(state);
      if (selected_area) {
        selected_area.status = "Not Active" 
        selected_area.area_codes = [];
        this.$store.commit('updateSelectedArea', selected_area);
      } else {
        console.log("Not selected area found for the state");
      }

      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
      let context=this;
      _.forEach(this.$store.getters.areaCodes,(city) => {
          city.selected = false;
        if(city.mapLabel && city.polygon){
          city.mapLabel.setContent("<div style='font-size:"+context.current_size+"px;' class='maplabel fs-1 text-center '>"+city.display+"</div>")
          city.polygon.setOptions({fillColor: '#8A8E93',strokeColor: '#8A8E93',zIndex: 10,})
        }
      })
    },
    selectEntireState(){
      // _.forEach(this.$store.getters.areaCodes, (area_code)=>{
      //   this.$store.dispatch('addAreaCode', {city:area_code, selectedstate: this.$store.getters.selectedState})
      // })
      // this.initialziSelected()
      let state = this.$store.getters.selectedState;
      let is_new = false;
      let selected_area = moverHelper.getSelectedArea(state);
      if (selected_area && selected_area.filter_set_id) {
        selected_area.total_area_codes = this.$store.getters.areaCodes.length;
      }

      if (!selected_area) {
        is_new = true;
        selected_area = {
          abbreviation: stateHelper.getAbbreviationByState(state),
          state: state,
          area_codes: [],
          total_area_codes: this.$store.getters.areaCodes.length
        }
      }
      selected_area.status = "Active" 
      selected_area.area_codes = [];

      _.forEach(this.$store.getters.areaCodes, (next_item)=>{
        selected_area.area_codes.push({
          zip_code: next_item.zipcode,
          area_code: next_item.area_code
        })
        // this.$store.dispatch('addAreaCode', {"area_code": next_item, "state": this.$store.getters.selectedState})
      })

      if (is_new) {
        this.$store.dispatch('addSelectedArea', selected_area);
      } else {
        this.$store.commit('updateSelectedArea', selected_area);
      }

      this.initialziSelected()
      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
    },
    retriveStateData(){
      // let abbr = getAbbreviation()
      let state_abbr = stateHelper.getAbbreviationByState(this.$store.getters.selectedState)

      this.$http.get('https://jockey.irelo.com/api/reporting/moving/map-counts/'+state_abbr+'?month=1').then(response=>{
        this.stateData = response.data;
        console.log(this.stateData)
        // this.stateData.two_rooms_or_more_percentage = stateData.two_rooms_or_more/this.stateData.total_leads
      }).catch(error => {

      })
    },
    backToMap() {
      this.$router.push('/pickup/get-state');
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Pickup/GetCode/get-code.script.js